
















































































import { computed, defineComponent, ref, toRefs } from '@vue/composition-api';
import { formatDuration } from '@tt4b/ttam-utils';

import ExpansionPanel from 'src/components/common/expansion-panel/index.vue';
import MaterialCover from './material-cover.vue';
import { PropType } from 'vue';
import AdaptiveListContainer from '@/components/common/adaptive-list-container/index.vue';

const name = 'ttam-material-echo';

export default defineComponent({
  name,

  components: {
    AdaptiveListContainer,
    MaterialCover,
    ExpansionPanel,
  },

  props: {
    isVideo: { type: Boolean, default: true },
    isLoading: { type: Boolean, default: false },
    /** 预校验请求中 */
    isPreChecking: { type: Boolean, default: false },
    /** 操作按钮，hover才出现 */
    isHoverButtons: { type: Boolean, default: false },
    /** 是否默认展示建议 */
    isDefaultExpend: { type: Boolean, default: false },
    /** 是否展示仙女棒图标（标识是否优化过） */
    isShowMagicIcon: { type: Boolean, default: false },
    /** 素材建议列表 */
    suggestionList: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    materialInfo: {
      type: Object as PropType<{
        name: string;
        width: number;
        height: number;
        duration: number;
        imageUrl: string;
        tip?: string;
      }>,
      default: () => ({}),
      required: true,
    },
  },
  setup(props, { emit }) {
    const { isPreChecking, materialInfo, suggestionList, isHoverButtons, isVideo } = toRefs(props);

    const isExpansion = ref(false);

    const materialTip = computed(() => materialInfo.value.tip);

    const imageUrl = computed(() => materialInfo.value.imageUrl ?? '');
    /** 素材名称 */
    const materialName = computed(() => materialInfo.value.name);
    /** 视频时长 */
    const videoDuration = computed(() => `${formatDuration(materialInfo.value.duration)}` || '');
    /** 素材分辨率 */
    const materialResolution = computed(() => {
      const { width, height } = materialInfo.value;
      return width && height ? `${width} * ${height}` : '';
    });

    /**
     * 素材本地校验不通过，预校验正在请求中
     * 在建议列表下方展示loading图
     */
    const isBottomLoadingVisible = computed(() => suggestionList.value.length > 0 && isPreChecking.value);

    /**
     * 素材本地校验通过，预校验正在请求中
     * 在素材信息右侧展示loading图
     */
    const isRightSideLoadingVisible = computed(() => suggestionList.value.length === 0 && isPreChecking.value);

    // const errorContent = computed(() => {
    //   if (isEdit.value && materialInfo?.status === CreativeVideoStatus.TRANSCODE_FAIL) {
    //     return i18n.t('creative_current_video_transcode_fail_hover');
    //   } else if (materialInfo?.rejectReason) {
    //     return materialInfo.rejectReason || '';
    //   }
    //   return '';
    // });

    const onClick = () => {
      // 当开始了动态创意时，这个地方就是可以点击，选择后，预期组件的联动显示
      if (isHoverButtons.value) {
        emit('click');
      }
    };

    const hasPlayIcon = computed(() => isVideo.value && Boolean(materialResolution.value));

    return {
      isExpansion,
      imageUrl,
      videoDuration,
      materialTip,
      materialName,
      materialResolution,
      hasPlayIcon,

      isBottomLoadingVisible,
      isRightSideLoadingVisible,
      onClick,
    };
  },
});
